import axios from 'axios'
import { showToast, showLoadingToast, closeToast } from 'vant'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const quiet =
      config.silent === true
    if (!quiet) {
      showLoadingToast({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
    }
    return config
  },
  error => {
    closeToast()
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    closeToast()
    const res = response.data

    // 判断返回状态
    if (res.code === 200) {
      return res.data
    } else {
      // 业务错误
      const errorMsg = res.msg || '请求失败'
      showToast({
        message: errorMsg,
        position: 'middle',
        duration: 3000
      })
      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    closeToast()

    // 网络错误或服务器错误
    let message = '网络请求失败'
    if (error.response) {
      message = `服务器错误(${error.response.status})`
    } else if (error.message && error.message.includes('timeout')) {
      message = '请求超时，请重试'
    } else if (error.message) {
      message = error.message
    }

    showToast({
      message: message,
      position: 'middle',
      duration: 3000
    })

    return Promise.reject(new Error(message))
  }
)

export default request
